import { Column, Row } from 'hatch-components';
import UserAvatar from 'root/components/molecules/UserAvatar';
import styled from 'styled-components';

const USER_AVATAR_WIDTH = 44;

export const StyledDefaultTemplateLeftColumnUserDetails = styled(Row)(
  ({ theme: { spacing } }) => ({
    alignItems: 'center',
    margin: `0 ${spacing.md}`,
    width: `calc(100% - ${spacing.md} - ${spacing.md})`,
  }),
);

export const StyledUserDetailsWrapper = styled(Column)(() => ({
  justifyContent: 'center',
  width: `calc(100% - ${USER_AVATAR_WIDTH}px - 16px)`,
}));

export const StyledSignedInAs = styled.h1(({ theme: { colors, font } }) => ({
  color: colors.lavender,
  fontSize: font.size.sm,
  fontWeight: font.weight.normal,
  height: font.lineHeight.sm,
  lineHeight: font.lineHeight.sm,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '100%',
}));

export const StyledUserFullName = styled.h2(({ theme: { colors, font } }) => ({
  color: colors.secondary,
  fontSize: font.size.sm,
  fontWeight: font.weight.extraBold,
  height: font.lineHeight.sm,
  lineHeight: font.lineHeight.sm,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  width: '100%',
}));

export const StyledUserAvatar = styled(UserAvatar)(() => ({
  height: USER_AVATAR_WIDTH,
  marginRight: 16,
  width: 44,
}));

export const StyledImpersonating = styled.small(
  ({ theme: { colors, font, spacing } }) => ({
    alignItems: 'center',
    background: colors.success,
    borderRadius: 36,
    color: colors.white,
    display: 'flex',
    flexShrink: 0,
    fontSize: font.size.md,
    fontWeight: font.weight.bold,
    height: 36,
    justifyContent: 'center',
    lineHeight: font.lineHeight.md,
    margin: `0 ${spacing.md} ${spacing.md} ${spacing.md}`,
    padding: `${spacing.xxs} ${spacing.xs}`,
    userSelect: 'none',
    width: `calc(100% - ${spacing.md} - ${spacing.md})`,
  }),
);
